import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { logout } from "../../slices/userSlice";
import { useIsAuthenticatedQuery } from "../../api/userApi";

export const AuthSessionGuard = (): null => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const location = useLocation();

    const isAuthenticated = useAppSelector(state => state.user.isAuthenticated);

    const { data: serverIsAuthenticated } = useIsAuthenticatedQuery(undefined, {
        skip: !isAuthenticated,
        pollingInterval: 30000,
        refetchOnFocus: true,
        refetchOnReconnect: true
    });

    useEffect((): void => {
        if (isAuthenticated && serverIsAuthenticated === false) {
            console.log("Calling root logout");
            dispatch(logout());
        }
    }, [dispatch, isAuthenticated, serverIsAuthenticated]);

    useEffect((): void => {
        if (!isAuthenticated && location.pathname !== "/") {
            console.log("Calling root nav");
            navigate("/", { replace: true });
        }
    }, [isAuthenticated, location.pathname, navigate]);

    return null;
};
